import React from "react";
import cn from "classnames";
import styles from "./RepresentativeInformation.module.sass";
import Card from "../../../components/Card";
import TextInput from "../../../components/TextInput";
import PhoneInput from "../../../components/PhoneInput";

const RepresentativeInformation = ({ className, data, updateData, currentStep }) => {
  // Utiliser directement les données de l'entreprise transmises par le parent
  const companyData = data?.company || {};

  // Gestionnaires pour les changements de données
  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    
    // Mettre à jour les données du représentant légal
    if (updateData) {
      updateData('representativeInfo', { ...data.representativeInfo, [name]: value });
    }
  };

  const handleDropdownChange = (name, value) => {
    // Mettre à jour les données du représentant légal
    if (updateData) {
      updateData('representativeInfo', { ...data.representativeInfo, [name]: value });
    }
  };

  // Fusionner les données de l'entreprise avec les modifications en cours
  const currentData = { ...companyData, ...data.representativeInfo };

  return (
    <Card className={cn(styles.card, className)} title="Représentant légal et financier" classTitle="title-green">
      <div className={styles.group}>
        <TextInput
          className={styles.field}
          label="Nom du directeur"
          name="last_name"
          type="text"
          placeholder="Nom du directeur"
          value={currentData?.director_last_name || ''}
          onChange={handleCompanyChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Prénom du directeur"
          name="first_name"
          type="text"
          placeholder="Prénom du directeur"
          value={currentData?.director_first_name || ''}
          onChange={handleCompanyChange}
        />
        <PhoneInput
          className={styles.field}
          label="Numéro de téléphone du directeur"
          name="phone"
          id="director_phone"
          placeholder="+33 6 XX XX XX XX"
          value={currentData?.director_phone || ''}
          onChange={handleCompanyChange}
          autoComplete="tel"
        />
        <TextInput
          className={styles.field}
          label="Email du directeur"
          name="email"
          type="email"
          placeholder="email@example.com"
          value={currentData?.director_email || ''}
          onChange={handleCompanyChange}
          required
        />
      </div>
    </Card>
  );
};

export default RepresentativeInformation;
